import t1 from "../MainPage/TeachersBlock/1.jpg";
// import t2 from "../MainPage/TeachersBlock/2.jpg";
// import t3 from "../MainPage/TeachersBlock/3.jpg";
import t4 from "../MainPage/TeachersBlock/4.jpg";
import t5 from "../MainPage/TeachersBlock/5.jpg";
import t6 from "../MainPage/TeachersBlock/6.jpg";
import t7 from "../MainPage/TeachersBlock/7.jpg";
import t8 from "../MainPage/TeachersBlock/8.jpg";
import t9 from "../MainPage/TeachersBlock/9.jpg";
import t10 from "../MainPage/TeachersBlock/10.jpg";
import t11 from "../MainPage/TeachersBlock/11.jpg";
import t12 from "../MainPage/TeachersBlock/12.jpg";
import t13 from "../MainPage/TeachersBlock/13.jpg";
import t14 from "../MainPage/TeachersBlock/14.jpg";
import pol from "./pol.jpg";

export const levels = {
  A1A2: {
    teachers: [
      // Ex-teacher
      // {
      //   img: t2,
      //   name: "Руслана",
      //   month: "вересень",
      //   description:
      //     "Освітній ступінь: бакалавр. Вчитель початкових класів з правом викладання англійської мови. Київський університет імені Бориса Грінченка",
      // },
      {
        img: t1,
        name: "Лера",
        month: "жовтень",
        description:
          "Магістр філології, спеціалізація: германські мови та літератури (переклад включно, перша – англійська); магістр права, спеціальність: право. Чернівецький національний університет ім. Юрія Федьковича.",
      },
      // Ex-teacher
      // {
      //   img: t3,
      //   name: "Маша",
      //   month: "листопад",
      //   description:
      //     "Освітній ступінь: бакалавр Германської мови та літератури (англійська та французька) ДНУ ім. Олеся Гончара.",
      // },
    ],
  },
  A2B1: {
    teachers: [
      {
        img: t4,
        name: "Ілля",
        month: "вересень",
        description:
          "Освітній ступінь: магістр міжнародних відносин та суспільних комунікацій, Київський столичний університет імені Бориса Грінченка. Сертифікація: IELTS C1 2024",
      },
      {
        img: t6,
        name: "Стас",
        month: "жовтень",
        description:
          "Освітній ступінь: магістр філології. Дніпровський національний університет ім. Олеся Гончара.",
      },
      {
        img: t5,
        name: "Влада",
        month: "листопад",
        description:
          "Освітній ступінь: магістр англійської філології (Германські мови та література (включаючи переклад) перша – англійська мова) Національного авіаційного університету.",
      },
    ],
  },
  B1B2: {
    teachers: [
      {
        img: t7,
        name: "Таня",
        month: "вересень",
        description:
          "Освітній ступінь: бакалавр (філолог та перекладач), англійська мова та література (переклад включно) та друга іноземна мова (німецька), нині закінчую магістратуру за тією ж спеціальністю. Харківський національний університет імені В.Н.Каразіна (факультет іноземних мов)",
      },
      {
        img: t8,
        name: "Діана",
        month: "жовтень",
        description:
          "Освітній ступінь: бакалавр. Спеціалізація Германські мови та літератури (переклад включно) університет ДоНУ імені Василя Стуса.",
      },
      {
        img: t9,
        name: "Аня",
        month: "листопад",
        description:
          "Освітній ступінь: Львівський національний університет ім. Івана Франка. Сертифікація: IELTS C1 2024.",
      },
    ],
  },
  B1plusB2: {
    teachers: [
      // Ex-teacher
      // {
      //   img: t2,
      //   name: "Руслана",
      //   month: "вересень",
      //   description:
      //     "Освітній ступінь: бакалавр. Вчитель початкових класів з правом викладання англійської мови. Київський університет імені Бориса Грінченка",
      // },
      {
        img: t14,
        name: "Ліза",
        month: "жовтень",
        description:
          "Освітній ступінь: бакалавр культурології. Університет митної справи та фінансів.",
      },
      {
        img: t13,
        name: "Марина",
        month: "листопад",
        description:
          "Освітній ступінь: Бакалавр історії (з поглибленим вивченням іноземних мов). Київський національний університет імені Тараса Шевченка.",
      },
    ],
  },
  B2C1: {
    teachers: [
      {
        img: t10,
        name: "Ганя",
        month: "вересень",
        description: "Сертифікація: IELTS 8.5 (C2) 2024",
      },
      {
        img: t12,
        name: "Оскар",
        month: "жовтень",
        description: "Сертифікація: САЕ С2 2024",
      },
      {
        img: t11,
        name: "Даріна",
        month: "листопад",
        description:
          "Освітній ступінь: бакалавр біології та біохімії ХНУ імені Каразіна. Сертифікація: IELTS 8 (C1) 2024",
      },
    ],
  },
  C1C2: {
    teachers: [
      {
        img: t4,
        name: "Ілля",
        month: "вересень",
        description:
          "Освітній ступінь: магістр міжнародних відносин та суспільних комунікацій, Київський столичний університет імені Бориса Грінченка. Сертифікація: IELTS C1 2024",
      },
      {
        img: pol,
        name: "Поліна",
        month: "жовтень",
        description:
          "Освітній ступінь: магістр. Факультет іноземних мов,англійська мова та світова література. Ізмаїльський Державний Гуманітарний Університет.\n" +
          "Сертифікація: IELTS 8 (C1) 2024. TOEFL C1 2025.",
      },
      {
        img: t11,
        name: "Даріна",
        month: "листопад",
        description:
          "Освітній ступінь: бакалавр біології та біохімії ХНУ імені Каразіна. Сертифікація: IELTS 8 (C1) 2024",
      },
    ],
  },
};

export const programs = {
  A1A2: {
    grammar: [
      "verb be +",
      "verb be - and ?",
      "possessive adjectives",
      "prepositions of place",
      "singular and plural nouns",
      "nouns",
      "imperatives",
      "present simple + and -",
      "present simple ?",
      "word order in questions",
      "possessive 's; Whose...?",
      "prepositions of time",
      "telling the time",
      "adverbs and expressions of frequency",
      "can/can’t",
      "present continuous",
      "present simple or present continuous",
      "demonstratives (this/that/these/those)",
      "object pronouns",
      "like + (verb-ing)",
      "be or do",
      "past simple of be",
      "past simple (regular verbs)",
      "past simple (irregular verbs)",
      "there is/there are, some/any",
      "there was/were",
      "countable and uncountable nouns, a/an/some/any",
      "quantifiers",
      "comparatives",
      "superlative adjectives",
      "to be going to (plans)",
      "to be going to (predictions)",
      "adverbs (manner and modifiers)",
      "verbs + to + infinitive",
      "definite and indefinite articles",
      "present perfect",
      "present perfect vs past simple",
    ],
    vocabulary: [
      "days of the week",
      "numbers 0-20",
      "countries",
      "belongings",
      "common adjectives",
      "feelings",
      "verb phrases",
      "jobs and leisures",
      "question words",
      "family",
      "daily routine",
      "time",
      "clothes",
      "weather and seasons",
      "words in a story",
      "dates and ordinal numbers",
      "music",
      "word formation",
      "past time expressions",
      "phrases with go, have, get",
      "directions",
      "the house",
      "prepositions of place and movement",
      "food and drink",
      "food containers",
      "high numbers",
      "places and buildings",
      "city holidays",
      "common adverbs",
      "verbs that take the infinitive",
      "technology",
      "irregular verbs",
      "past simple vs past participle",
    ],
    speaking: [
      "giving personal information",
      "asking for personal information",
      "describing the things you have",
      "building conversations",
      "identifying & describing locations of the objects",
      "describing things",
      "giving instructions",
      "telling about the country",
      "discussing the jobs",
      "being polite",
      "describing family photos",
      "telling about your daily routine",
      "asking and telling the time",
      "telling about your life",
      "challenges",
      "questionnaire: Can you…?",
      "spot the differences",
      "places in a city",
      "in a shop (buying clothes)",
      "retelling a story",
      "talking about favourite and least favourite seasons/months/times of day",
      "questionnaire: My music",
      "great people of the past",
      "forming and answering Did you… questions",
      "a memorable past event",
      "giving and asking for directions",
      "breaking down the alibi of a robbery suspect",
      "renting a house or flat",
      "Was there...? questionnaire",
      "understanding the menu",
      "discussing food preferences",
      "comparing meals and prices",
      "ordering a meal",
      "asking about places of living",
      "describing your days-off",
      "predicting future",
      "talking about people in your country",
      "discussing your preferences",
      "talking about IT",
      "planning the trip",
      "building the conversation",
      "summarizing and sharing our impressions",
    ],
  },
  A2B1: {
    grammar: [
      "word order in questions",
      "present simple",
      "present continuous",
      "calling reception",
      "past simple: regular and irregular",
      "past continuous",
      "time sequencers and connectors",
      "be going to (plans and predictions)",
      "present continuous (future arrangements)",
      "defining relative clauses",
      "at the restaurant",
      "present perfect + yet, just, already",
      "present perfect or past simple? (1)",
      "something, anything, nothing, etc.",
      "comparative adjectives and adverbs, as ... as",
      "superlatives (+ ever + present perfect)",
      "quantifiers, too, (not) enough",
      "taking something back to a shop",
      "will / won’t (predictions)",
      "will / won’t / shall (other uses)",
      "review of verb forms: present, past, and future",
      "uses of the infinitive with to",
      "uses of the gerund (verb + -ing)",
      "have to, don’t have to, must, mustn’t",
      "going to the pharmacy",
      "should",
      "first conditional (if + present, will + infinitive)",
      "possessive pronouns",
      "second conditional (if + past, would + infinitive)",
      "present perfect + for and since",
      "present perfect or past simple? (2)",
      "asking how to get there",
      "expressing movement",
      "word order of phrasal verbs",
      "the passive",
      "used to",
      "might",
      "so / neither + auxiliaries",
      "on the phone",
      "past perfect",
      "reported speech",
      "questions without auxiliaries",
    ],
    vocabulary: [
      "common verb phrases",
      "describing people: appearance and personality",
      "clothes",
      "prepositions of place",
      "holidays",
      "prepositions of time and place: at, in, on",
      "verb phrases",
      "airports",
      "verbs + prepositions",
      "paraphrasing",
      "restaurants",
      "housework, make or do?",
      "shopping",
      "adjectives ending -ed and -ing",
      "types of numbers",
      "describing a town or city",
      "health and the body",
      "opposite verbs",
      "verb + back",
      "modifiers",
      "verbs + infinitive: try to, forget to, etc.",
      "verbs + gerund",
      "adjectives + prepositions: afraid of, etc.",
      "feeling ill",
      "get",
      "confusing verbs",
      "adverbs of manner",
      "animals and insects",
      "words related to fear",
      "phrases with for and since",
      "biographies",
      "directions",
      "sports",
      "phrasal verbs",
      "people from different countries",
      "school subjects",
      "word building: noun formation",
      "similarities and differences",
      "time expressions",
      "say or tell?",
      "revision of question words",
    ],
    speaking: [
      "describing someone you know",
      "describing a picture",
      "telling about your last holiday",
      "talking about photos: sharing memories and stories",
      "inventing a story",
      "plan a day trip for visitors",
      "making plans for a week",
      "define a word",
      "talking about the household routine",
      "talking about shopping experience",
      "talking about your weekend",
      "how has your life changed over the last three years?",
      "talking about life experience",
      "diet discussion",
      "making predictions about the future",
      "discuss life situations using topical vocabulary",
      "ask and answer questions in different tenses",
      "ask and answer questions using to + infinitive",
      "discuss preferences using -ing",
      "giving advice",
      "talk about real-life situations using useful words",
      "what would you do...?",
      "talking about life experience - Have you ever…?",
      "talk about people you know & their lives",
      "discussing sport",
      "phrasal verb questionnaire",
      "invention quiz",
      "talking about your life in the past",
      "talking about important life decisions",
      "finding people with the same & different interests",
      "tell a story",
      "talk about gossips",
      "general knowledge quiz",
    ],
  },
  B1B2: {
    grammar: [
      "Noun phrases",
      "Comparisons",
      "Non-defining relative clauses",
      "Present simple vs. continuous",
      "Present habits",
      "Used to / would / past simple",
      "Obligation and permission",
      "Present perfect simple",
      "Present perfect continuous",
      "Past simple and continuous",
      "Past tenses",
      "Past perfect",
      "Reported speech",
      "Future forms",
      "Adverbs used with the present perfect",
      "Comment adverbs",
      "Passive voice",
      "Have/get smth done",
      "Verb patterns",
      "First Conditional",
      "Time conjunctions",
      "Second Conditional",
      "Past modals of deduction",
      "Third Conditional",
      "Adjective word order",
      "Comprehensive review of all B1+ grammar structures",
    ],
    vocabulary: [
      "Types of food, eating out",
      "Housing, areas, locations",
      "Free time, going out vs staying in",
      "Expressions of preference and reasons",
      "Learning new skills",
      "Starting university, work, life events",
      "Family and childhood, lifestyle",
      "Polite phrases, small talk",
      "Tourist destinations and sightseeings",
      "Media, innovation, discovery",
      "Social rules, cultural customs, norms",
      "Cause/effect, connectors",
      "Experience, personal growth",
      "Running a company",
      "New projects",
      "Education",
      "Agree or disagree",
      "At the cinema, on TV",
      "Service and recommendations",
      "In the news",
      "Apologizes and make excuses",
      "Health problems",
      "Money",
      "On the road",
      "Deal with problems with shops and services",
      "Environmental issues and sustainability",
      "Traits of character",
      "Personal life milestones",
      "Giving reasons, redirecting",
      "Well-being, life satisfaction",
      "Community, social values",
      "Sport achievements",
      "Continuing, apologising, giving reasons",
      "Inspiring and influential people",
      "Achievements and setbacks",
      "Objects, features, and details",
      "Opinion leaders, ups and downs, main features",
    ],
    speaking: [
      "Making decisions on places to eat",
      "Comparing living spaces",
      "Describing a night out",
      "Justifying your choices",
      "Planning a perfect weekend",
      "Discussing your progress and hobbies",
      "Describing first days and work experiences",
      "Comparing life then and now",
      "Social interactions",
      "Work and lifestyle changes, advice for a newcomer",
      "Recommending places to visit",
      "Talking about interesting news",
      "Giving advice and guidance",
      "Clarifying meaning and intentions",
      "Cultural misunderstanding",
      "Interview someone about future plans",
      "Talk about new projects",
      "Take part in discussion",
      "Agree and disagree",
      "Recommend services",
      "Discuss a health problem with a doctor",
      "Discuss money issues",
      "Tell a travel story",
      "Deal with problems with shops and services",
      "Learning how to discuss environment and nature",
      "Speaking about different types of relationships",
      "Sharing key personal experiences",
      "Roleplaying and justifying your intentions",
      "Turning points of life",
      "Conducting surveys, sharing your perfect lifestyle",
      "Expressing opinions and holding discussions",
      "Debating on memorable sports events",
      "Learning how to interrupt politely and meaningfully",
      "Imagining an ideal society and reflecting on personal well-being",
      "Describing someone’s influence",
      "Discussing successes and failures",
      "Describing objects or possessions",
      "Offering help and declining politely",
      "My journey of growth",
      "Learn how to express your thoughts clearly, support your opinions, and engage in meaningful discussions and debates",
    ],
    functionalLanguage: [
      "Expressing likes/dislikes",
      "Ending conversations",
      "Giving explanations",
      "Giving advice",
      "Roleplaying",
      "Offering – accepting or declining",
      "Polite interruptions",
    ],
    review: [
      "Mix of Lessons 1–4 grammar",
      "Integrated (food, home, leisure)",
      "Mix of Lessons 6–10 grammar",
      "Integrated (experience, personal growth)",
      "Mix of Lessons 11–15 grammar",
      "Integrated (travel, society, advice)",
      "Past perfect, past simple, past continuous, reported speech",
      "Integrated (accidents, reactions, mistakes, crime in news, complaints)",
      "Future forms, adverbs used with the present perfect, comment adverbs",
      "Integrated (running a company, new projects, education, agree and disagree)",
      "Passive voice, have/get smth done, probability",
      "Integrated (at the cinema, on TV, service and recommendations, in the news, apologizes and make excuses)",
      "Verb patterns, noun phases",
      "Integrated (health problems, money, on the road, deal with problems with shops and services)",
      "Integrated (environment, character, life events)",
      "Mix of Lessons 42–45 grammar",
      "Integrated (well-being, socializing, sports)",
      "Mix of Lessons 47–50 grammar",
      "Integrated (opinion leaders, ups and downs, main features)",
    ],
  },
  B1plusB2: {
    grammar: [
      "different types of pronouns",
      "word formation",
      "comparative and superlative adjectives",
      "mix of lessons 1–3",
      "present tenses",
      "I would rather",
      "mix of lessons 5–7; identifying grammatical structures",
      "possessives",
      "mix of lessons 9–11",
      "structures for giving opinion",
      "past tenses + used to",
      "prepositions",
      "mix of lessons 13–15",
      "word transformation",
      "Zero and first conditional",
      "Negotiation/Reaching agreement",
      "Mix of Lessons 17–19",
      "Future forms (will, shall, to be going to)",
      "Present perfect simple",
      "Present perfect continuous",
      "Mix of Lessons 21–23",
      "Modals for advice, necessity, prohibition",
      "Modals for ability and possibility",
      "Second conditional",
      "Mix of Lessons 25–27",
      "Present perfect simple vs. continuous; stative verbs",
      "Reflexive pronouns; obligation",
      "Polite modal structures; indirect language",
      "Mix of Lessons 29–31",
      "Question forms; indirect questions",
      "Cleft and emphasis structures",
      "Obligation, advice, necessity",
      "Mix of Lessons 33–35",
      "verb patterns (gerunds and infinitives)",
      "Reported speech",
      "should have / I wish..",
      "mix of lessons (37–39)",
      "phrasal verbs",
      "Clauses of contrast and purpose",
      "Verb patterns (want to do, suggest doing, persuade sb to do)",
      "mix of lessons (41–43)",
      "Passive voice (all tenses)",
      "Passive with reporting structures",
      "might have, must have, could have + past participle",
      "mix of lessons (45–47)",
      "Uncountable and plural nouns",
      "quantifiers (all, every, majority, minority etc)",
      "2nd and 3rd conditional",
      "mix of lessons (49–51)",
    ],
    vocabulary: [
      "names",
      "adjectives to describe people",
      "adjectives of opinion",
      "integrated (Unit 1)",
      "belongings for vacation",
      "details related to vacation",
      "expressions for recreations",
      "integrated (Unit 2)",
      "places for purchasing things",
      "shops: nouns and verbs",
      "expressions related to buying and selling things",
      "stages of life",
      "adjectives to describe people",
      "photography",
      "rubbish and recycling",
      "Habits, daily actions, sustainability",
      "Global warming and ecological issues",
      "Technology, predictions",
      "Milestones and timelines",
      "Ongoing actions and progress",
      "Rules and laws, dos and don’ts",
      "Everyday scenarios",
      "What-if scenarios",
      "Time expressions",
      "Personal care and duties",
      "Polite expressions and social norms",
      "Curiosity, engagement",
      "Debate and personal stance",
      "Suggestions and guidance",
      "leisure activities, personal preferences and decisions",
      "negotiating situations",
      "feelings",
      "money-related phrasal verbs",
      "describing media, advertising",
      "describing media; slogans",
      "Types of crimes (burglary, fraud, theft)",
      "what happens to a criminal (crime, trial)",
      "mystery, deduction, problem solving",
      "City features, infrastructure, common issues; word building",
      "global issues (poverty, illiteracy etc)",
      "Hypotheticals, imaginary alternatives, dreams",
    ],
    speaking: [
      "explaining the meaning of the names",
      "giving opinion, talking about colors",
      "building conversations with comparatives and superlatives",
      "developing fluency (Unit 1)",
      "best vacation strategies",
      "exchanging information",
      "showing preferences",
      "developing fluency and linking (Unit 2)",
      "elaborating your choice",
      "describing the shops in your area",
      "promoting your goods and services",
      "describing people",
      "sharing previous experience",
      "describing photos",
      "describing statistics",
      "Talking about routines and results",
      "Giving solutions",
      "Talking about the future",
      "Reflecting on personal achievements",
      "Talking about duration and activity",
      "Giving and reacting to advice",
      "Talking through possible actions",
      "Expressing hypothetical ideas",
      "Comparing experience and activity",
      "Talking about yourself",
      "Making requests and responding",
      "Asking and answering questions",
      "Expressing agreement and disagreement",
      "Recommending and responding",
      "debate staying in or going out; share preferences",
      "recall and summarise personal or heard stories",
      "Share past regrets and give advice",
      "discuss money management and spending habits",
      "Analyze misleading advertisements",
      "create a persuasive ad campaign",
      "Describe a past crime using passive structures",
      "discuss crime-related news and public beliefs",
      "Guess what happened in strange or unexplained situations",
      "Describe your city or hometown; compare rural and urban living",
      "discuss global issues and compare statistics",
      "what if? Debates about historical events and scientific development",
    ],
  },
  B2C1: {
    grammar: [
      "Present, Past, and Future Perfect",
      "Subject raising",
      "Infinitive phrases",
      "Mix of Lessons 1–4 grammar",
      "The continuous aspect",
      "Probability",
      "Cleft sentences",
      "Managing a fast-paced conversation",
      "Mix of lessons 6–9",
      "Question forms",
      "Reason clauses",
      "Ways of modifying adjectives",
      "Non-future uses of “will”",
      "Real conditionals",
      "Giving impressions",
      "Inversions for emphasis",
      "All the grammar from Unit 4",
      "Linking devices",
      "Modal verbs of deduction or regret, unreal conditionals",
      "Problems and hypothesise solutions",
      "Unreal conditionals for excuses",
      "Passive voice",
      "Formal recommendations; present subjunctive",
      "Comparatives",
      "Determiners",
      "Relative clauses",
      "Reduced relative clauses",
      "The future in the past",
      "Emphasising advice",
      "Narrative tenses",
      "Reported speech",
      "Participle clauses and verbless clauses",
      "Emphasis and persuasion",
      "Heads and tails",
      "Concession clauses",
      "Comprehensive review of all C1 grammar structures",
    ],
    vocabulary: [
      "Phrases with delexical verbs",
      "Idioms for expressing and controlling emotions",
      "Connotation 1",
      "Socializing",
      "Integrated",
      "Trends",
      "Agreement and disagreement",
      "Connotation 2",
      "Conversation",
      "Ideas",
      "Problems and solutions",
      "The news and reporting",
      "Idioms related to clarity",
      "Mix of all vocabulary lessons 1-14",
      "Anxiety and excitement",
      "Adjective + noun collocations",
      "The senses",
      "Negotiating",
      "Importance, usefulness",
      "Risk, success and failure",
      "Near-synonyms",
      "Excuses",
      "Making connections",
      "Regulation",
      "Responding to ideas",
      "Idioms and useful phrases",
      "Idioms related to exploration",
      "Deception",
      "Skills and abilities",
      "Debate",
      "Idioms related to feelings",
      "Decision making and reflection",
      "Idioms related to risk",
      "Verb-adverb collocations",
      "Gossip and rumours",
      "Improvement and deterioration",
      "Collocations: innovation",
      "Board games",
      "Evaluating",
      "Innovation, learning, succeeding, reporting",
      "Integrated vocabulary from all themes",
    ],
    speaking: [
      "Giving feedback on an event",
      "Controlling our own emotions",
      "Influencers and social media discussion",
      "Preparing to talk at a conference",
      "Reflecting on an event and emotional impact",
      "Presentation on past, current, and future trends",
      "Proposing changes to a workplace",
      "Preparing for a council meeting",
      "Maintaining a conversation",
      "Debating the impact of emerging trends on the future of work",
      "Using brainstorming techniques",
      "Solving a problem",
      "Discussing a news story",
      "Summarizing a text",
      "Presenting solutions to a current issue using brainstorming techniques",
      "Describing phobias",
      "Discussing political and social issues",
      "Answering questions about abstract topics",
      "Resolving conflicts",
      "Emotional intelligence in solving political problems",
      "Unrecognized people, jobs",
      "Importance of risk to success",
      "Ways to improve environments",
      "Politely refuse a request",
      "Society & values",
      "Dystopia",
      "Presenting formal recommendations",
      "Marketing ideas",
      "Has consumer culture improved or damaged modern life?",
      "Planning an unconventional journey",
      "Discuss money issues",
      "Skills and abilities",
      "Chair and participate in a debate",
      "Traveling and finances",
      "Carry out a survey",
      "Describe a pivotal moment in your life",
      "Create a list of survival tips",
      "Deal with problems on a call",
      "Relate a non-chronological narrative",
      "Take part in a work-based conversation",
      "Discuss a course of action",
      "Employability and competencies",
      "Job interview",
      "Present an idea",
      "Explain the rules of a game",
      "Discuss approaches to language learning",
      "Deliver a progress report",
      "Hustle culture",
      "Express your thoughts clearly, support your opinions, and engage in meaningful discussions and debates",
    ],
  },
  C1C2: {
    grammar: [
      "Inversion",
      "Inversion practice",
      "Inversion revision",
      "Gradable and ungradable adjectives",
      "Position of adjectives and adverbs",
      "All conditionals revision",
      "Mixed conditionals",
      "All conditionals and mixed conditionals",
      "Defining and non-defining relative clauses",
      "Reduced relative clauses",
      "Relative clauses revision",
      "Word formation",
      "Modal verbs (past forms, negative forms, need, dare)",
      "Cleft sentences",
      "Prepositions",
      "Future forms",
      "Prepositions and future forms",
      "Narrative tenses revision",
      "Reporting verb patterns",
      "Indirect questions",
      "Transitive and intransitive verbs",
      "Causative form",
      "Causative form revision",
    ],
    vocabulary: [
      "Personality and character idioms",
      "Idioms about lifestyle",
      "Travel and culture-related words",
      "Phrasal verbs about traveling",
      "Adjectives and adverbs",
      "Lessons 5–7",
      "Idioms and phrasal verbs connected to work",
      "Adverb-adjective phrases",
      "Lessons 9–11",
      "Verbs and adjectives about money",
      "Idioms about money",
      "Communication-related phrasal verbs",
      "Communication-related phrasal verbs revision",
      "Cohesive devices",
      "Expressions about anger",
      "Idioms about emotions",
      "Expressions to justify an opinion",
      "Compound nouns",
      "Collocations and expressions",
      "Phrases to write a review",
      "Lessons 25–27",
      "Food and eating habits vocabulary",
      "Lessons 29–31",
      "Education-related words",
      "Phrasal verbs related to education and studying",
      "Phrasal verbs related to education and studying revision",
      "Relationship-related vocabulary",
      "Relationship-related vocabulary revision",
      "Vocabulary from the article",
      "Vocabulary about consumerism",
      "Phrasal verbs about shopping",
      "Phrasal verbs about shopping revision",
      "Lessons 41–43",
      "Film genres and descriptive vocabulary",
      "Film-related vocabulary",
      "Vocabulary related to fear",
      "Lessons 45–47",
      "Socially-political vocabulary",
      "Lessons 49–50",
    ],
    speaking: [
      "Introducing yourself, getting to know each other better",
      "Role-playing different personality types",
      "Speaking about lifestyles",
      "Developing oral fluency",
      "Talking about traveling experience",
      "Explaining, recommending, reaching consensus",
      "Exchanging opinions about volunteering",
      "Talking about work experience",
      "Talking about first job experience",
      "Talking about regrets and wishes",
      "Talking about ways to save money",
      "Talking about money habits",
      "Talking about communication",
      "Speaking about social rules",
      "Speaking about online communication",
      "Developing speaking fluency",
      "Talking about conflicts",
      "Role-playing conflict situations",
      "Expressing and justifying one’s opinion",
      "Talking about technology",
      "Talking about robots replacing humans",
      "Developing learners’ fluency",
      "Talking about comfort food",
      "Talking about past food habits",
      "Interviewing each other",
      "Talking about advantages and disadvantages of higher education",
      "Talking about studying experience",
      "Presenting and explaining personal opinion",
      "Developing learners’ fluency",
      "Speaking about love languages",
      "Reporting each other’s words",
      "Talking about relationships and humour",
      "Developing oral fluency",
      "Talking about consumerism",
      "Talking about shopping",
      "Speaking about shopping habits",
      "Speaking about your favourite film",
      "Film review",
      "Creating a short plot for a horror movie",
      "Developing oral fluency",
      "Talking about pressing social issues",
      "Speaking about volunteering",
      "Developing oral fluency",
    ],
    writing: [
      "Writing a review on a gadget",
      "Creating a short plot for a horror movie",
    ],
  },
};
